import { Form, Select } from 'antd';
import { fieldIsRequired, periodsList } from '../../constants/constants';
import { selectHerePlaceholder } from '../../constants/translations';

export const PeriodSelection = () => (
  <Form.Item
    label="Pritaikymų laikotarpis"
    name={['registration', 'adaptationPeriod']}
    rules={[fieldIsRequired]}
  >
    <Select placeholder={selectHerePlaceholder} showSearch={true}>
      {periodsList.map((period, index) => (
        <Select.Option key={`period_item_${index + 1}`} value={period}>
          {period}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
